import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import _ from 'lodash';

const NavLink = ({ children, className, dropdown, id, noLink, onlyActiveOnIndex, onClick, target, to }) => {
    return (
            _.startsWith(to, 'http') ?
            (
                <li className="nav-item">
                    <a
                        href={to}
                        className={className}
                        target={target}
                        onClick={onClick}
                    >
                        {children}
                    </a>
                </li>
            ) :
            (
                dropdown
                ? dropdown
                : (
                    <li className="nav-item">
                        {
                            noLink
                            ?
                                children
                            :
                                <Link
                                    id={id}
                                    to={to}
                                    className={className}
                                    target={target}
                                    activeClassName="active"
                                    onlyActiveOnIndex={onlyActiveOnIndex}
                                    onClick={onClick}
                                    role={"button"}
                                >
                                    {children}
                                </Link>
                        }
                    </li>
                )
            )
    );
};


NavLink.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    dropdown: PropTypes.node,
    id: PropTypes.string,
    noLink: PropTypes.bool,
    onClick: PropTypes.func,
    onlyActiveOnIndex: PropTypes.bool,
    target: PropTypes.string,
    to: PropTypes.string,
};

export default NavLink;


/** WEBPACK FOOTER **
 ** ./src/components/NavLink.js
 **/